import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { getDictionaries, getUserProfile, getUserRestaurants } from '../../services/api';

const useOwnerSettingsData = () => {
  const { tokens, email, authenticatedFetch } = useAuth();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [restaurants, setRestaurants] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState([]);

  useEffect(() => {
    if (!email || !tokens) {
      navigate('/restaurant/login');
      return;
    }

    getUserProfile(email, authenticatedFetch)
      .then((data) => {
        setUser(data);
        return getUserRestaurants(data.id, authenticatedFetch);
      })
      .then(setRestaurants)
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));

    getDictionaries(authenticatedFetch)
      .then((data) => {
        setCurrencies(Array.isArray(data?.currencies) ? data.currencies : []);
        setPaymentMethods(Array.isArray(data?.payment_methods) ? data.payment_methods : []);
      })
      .catch(() => {
        setCurrencies([]);
        setPaymentMethods([]);
      });
  }, [email, tokens, authenticatedFetch, navigate]);

  return { email, authenticatedFetch, user, loading, error, restaurants, currencies, paymentMethods };
};

export default useOwnerSettingsData;
